export default "/_next/static/f99f8324cdbeda9086f998ea4c8ef73c.png";